

import { IListResource } from '~src/httpClient/resources/Resource';
import { IResourceQuery, ResourceQuery } from '~src/httpClient/resources/ResourceQuery';

import { LabelValueResourceFetcher } from '../fetchers/LabelValueResourceFetcher';
import { ILabelValueInfo } from '../models/ILabelValueInfo';

export class LabelValuesResource implements IListResource<ILabelValueInfo>{
    private getLabelValuesRest = new LabelValueResourceFetcher();

    public static readonly instance = new LabelValuesResource();

    public all(): IResourceQuery<ILabelValueInfo> {
        return new ResourceQuery<ILabelValueInfo>(this.getLabelValuesRest);
    }
}

export default LabelValuesResource.instance;

